export const PermissionCupons = {
    PUT: "mgr-campaigns-**-PUT",
    POST: "mgr-campaigns-POST",
    DELETE: "mgr-campaigns-**-DELETE",
    GET: "mgr-campaigns-search-GET",
    GET_UUID: "mgr-campaigns-**-GET"
};